import styled from 'styled-components';

export const VerificationAgreementWrapper = styled.div`
.title {
			font-size: 36px;
			color: #FFFFFF;
			letter-spacing: 1px;
            font-weight: bold;
            margin-bottom: 1px;
            padding-left: 2rem;
		}
.verify-agree-wrapper {
 .ant-tabs-nav .ant-tabs-tab-active , .ant-tabs-tab, .white-text {
    color: #FFFFFF !important;
} .ant-tabs-ink-bar {
    top: 0px;
    height: 4px !important;
    background-color: #FFFFFF !important;
}
.font-size {
        font-size: 12px;
    }
.d-flex{
    display: flex;
}
.ant-tabs-nav .ant-tabs-tab {
    font-size: 15px;
}.ant-input-affix-wrapper {
    width: 33%;
} .ant-tabs-bar {
    border-top: 1px solid #e8e8e8;
    border-bottom: 0px !important;
    padding-left: 2rem;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
}
.form-disable {
    opacity: 0.5;
    pointer-events: none;
}
.status-submitting-icon path {
    fill: #FF8800;
}
.header-status {
    width: 6rem;
    word-break: break-word;
}
.red-text {
    color:#FF0000
}
.green-text {
    color: #009B29;
}
.orange-text {
    color: #FF8800 ;
}
.submit-state {
    width: 9rem;
    color: #FF8800;
}
.img-field-submit-state {
    text-align: center;
}
.header-content {
    width: 36rem;
    line-height: 1rem;
}
.submit-btn {
    width: 33%;
    margin-top: 1.5rem;
}
.status-incomplete-field {
    display: flex;
    justify-content: center;
    flex-direction: column;
    text-align: center;
    margin: 1rem 0rem 1rem 0rem;
    height: auto;
    background-color: #707070;
    width: 8%;
}
.section-wrapper {
    margin: 1rem 0rem 1rem 9.5rem;
    width: 80%;
    background-color: #212121;
	color: #ffffff;
    padding: 2rem;
}
.submit-header-business {
    margin-left: 37rem;
    color: #ffffff;
}
.pending-icon {
    height: 13px;
    width: 13px;
    background-color: #FF8800;
    border-radius: 10px;
    padding: 2px;
    margin-left: 3.5rem;
}
.bold {
    color: #000000;
}
.business-form-wrapper, .operator-form-wrapper, .agreement-content-wrapper, .operator-wrapper {
    .submit-content-wrapper {
        display: flex;
        justify-content: space-between;
        margin-left: 9.5rem;
        padding-right: 2.5rem;
    }
}
.operator-form-wrapper {
    .section-wrapper {
        width: 90%;
    }
}
@media (max-width: 1440px) {
    .operator-wrapper .operator-form-wrapper .phone-container .error-wrapper .ant-input-affix-wrapper {
        width: 36%;
    }
}

@media (max-width: 1439px) and (min-width: 1025px) {
    .verify-agree-wrapper .ant-input-affix-wrapper, .submit-btn {
        width: 50% !important;
    }
}
@media (max-width: 1024px) {
    .ant-input-affix-wrapper, .submit-btn {
        width: 50% !important;
    }
    .status-incomplete-field {
        width: 13%;
    }
}
@media (max-width:768px) {
    .operator-wrapper .submit-content-wrapper, .business-form-wrapper .submit-content-wrapper {
        margin-left: 3rem;
    }
    .requirement-wrapper-submit {
        margin-left: 3rem !important;
    }
    .section-wrapper {
        margin: 1rem 0rem 1rem 0rem;
         width: 100%;
    }
    .status-incomplete-field {
        width: 16% !important;
        font-size: 15px;
    }
}
@media (max-width:550px) {
    .operator-wrapper .submit-content-wrapper {
        flex-direction: column;
        .submit-header {
            padding-left: 0.5rem;
        }
    }
    .ant-input-affix-wrapper, .submit-btn {
        width: 100% !important;
    }
    .business-form-wrapper .submit-content-wrapper {
        margin-left: 3rem;
        flex-direction: column;
        .submit-header {
            padding-left: 0.5rem;
        }
    }
}
@media (max-width: 320px) {
    .status-incomplete-field {
        /* width: 16% !important; */
        font-size: 13px;
    }
}
@media (max-width:280px) {
    .section-wrapper {
        margin: 1rem 0rem 1rem 0rem;
        width: 80%;
    }
}
`
export const HeaderWrapper = styled.div`
.d-flex {
    display: flex;
}
.headerWrapper {
    display: flex;
    margin: 1rem 0rem 0rem 1rem;
} 
.submit-state-img {
    text-align: center;
}
.img-field {
    margin-left: 0.5rem;
    text-align: center;
}
.business-content, .submit-state-header {
    margin-left: 2.5rem;
    p {
        margin-bottom: 0px;
    }
    .business-header {
        margin: 10px 0px 24px 0px;
        font-weight: bold;
    }
    .business-content-details {
        margin-top: 1.5rem;
    }
}
.business-content {
    margin-left: 2rem !important;
}
.submit-content-wrapper{
    margin-top: 2rem;
}
.submit-message {
    /* margin:1rem 9.5rem 0rem 10rem; */
    color: #ffffff;
}
.clock-icon {
     margin: 3px 5px;
}
.submit-header {
    /* margin-left: 29rem; */
    color: #ffffff;
}
.submit-content {
        color: #A8A8B1;
        /* margin-top: 1rem; */
}
@media (max-width:768px) {
    .headerWrapper {
        display: flex;
        flex-direction: column;
    }
    .status-container {
        display: flex;
        justify-content: center;
    }
    .header-content {
        width: 100%;
    }
}
`

export const OperatorFormWrapper = styled.div`
.pointer-none {
    opacity: 0.5;
    pointer-events: none;
}  
.operator-form-wrapper .section-wrapper {
    margin: 1rem 0rem 1rem 0rem;
    padding: 0rem !important;
    background-color: unset;
		.ant-form,.quick-restart-card {
			 background-color: #212121;
      	 	 padding: 2rem 3rem;
             margin-left: 9.5rem;
		}
        .phone-verfication-wrapper {
            .phone-container {
                .ant-input-prefix {
                    color: #ffffff;
                    left: 0px;
                    height: 100%;
                    .country-calling-code {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        background-color: #707070;
                        width: 3.5rem;
                        height: 100%;
                    }
                }
                .ant-input {
                    padding-left: 5rem;
                }
            }
            .error-msg-container {
                color: red;
                background-color: #303236;
                margin-left: 1rem;
                display: flex;
                align-items: center;
            }
            .time-container {
                color: #A8A8B1;
                padding: 0 0.5rem;
                .sub-content {
                    font-weight: bold;
                    padding-left: 0.5rem;
                }
            }
        }
	}
    .align-center {
        align-items:center;
    }
    .anticon-info-circle {
        margin-bottom:0.4em;
    }
.operator-form-wrapper{
 .ant-input {
    width: 33%;
    border-radius: 0%;
}
.ant-form-item-control {
    line-height: 20px;
}
form .ant-select {
    width: 33%;
}
.ant-input-affix-wrapper .ant-input:not(:first-child) {
    padding-left: 10px;
}
}
.sms-code .ant-input {
    width: 100%;
}
h3, h4 {
    font-weight: bold;
    padding-right:5px;
}
.send-sms {
    color: #fff;
    cursor: pointer;
}
.proof-of-identity-content {
    margin-top: 1rem;
    p {
        margin-bottom: 0px;
    }
}
@media (max-width: 1439px) {
    .phone-verfication-wrapper .phone-number-message {
        flex-direction: column;
    }
    .phone-verfication-wrapper .error-msg-container {
        width: 50% !important;
        margin: 1rem 0rem 0rem 0rem !important;
    }
    .operator-form-wrapper {
        .ant-input {
            width: 50% !important;
        }
    }
    form .ant-select {
        width: 50% !important;
    }
    .sms-code .ant-input {
        width: 100% !important;
    }
    .phone-verfication-wrapper .sms-message-wrapper {
        flex-direction: column;
    }
    .operator-form-wrapper .section-wrapper .phone-verfication-wrapper .time-container {
        padding: 0.5rem 0.5rem !important;
    }
}
@media (max-width: 1024px) {
    .operator-form-wrapper {
        .ant-input {
            width: 50% !important;
        }
    }
    form .ant-select {
        width: 50% !important;
    }
    .sms-code .ant-input {
        width: 100% !important;
    }
    .phone-verfication-wrapper {
        .time-container {
                    font-size: 12px;
                    padding: 0.5rem 0.5rem !important;
                    .sub-content {
                        font-size: 12px;
                        padding-top: 2px;
                    }
                }
    }
    .phone-verfication-wrapper .phone-number-message {
        flex-direction: column;
    }
    .phone-verfication-wrapper .error-msg-container {
        width: 50% !important;
        margin: 1rem 0rem 0rem 0rem !important;
    }
    .phone-verfication-wrapper .sms-message-wrapper {
        flex-direction: column;
    }
    .operator-form-wrapper .section-wrapper .phone-verfication-wrapper .phone-container .display-none {
        display: none;
    }
}
@media (max-width:768px) {
    .operator-form-wrapper .section-wrapper .ant-form {
        margin-left: 0px;
    }
    .operator-form-wrapper .section-wrapper .phone-verfication-wrapper .phone-container .ant-input {
        text-overflow: ellipsis;
    }
    .ant-input-affix-wrapper .ant-input:not(:last-child) {
        padding-right: 40px;
    }
    .phone-verfication-wrapper .phone-number-message {
        flex-direction: column;
    }
    .phone-verfication-wrapper .error-msg-container {
        width: 50% !important;
        margin: 1rem 0rem 0rem 0rem !important;
    }
}
@media (max-width:550px) {
    .operator-form-wrapper .section-wrapper .ant-form {
        padding: 1rem 1.25rem;
    }
    .operator-form-wrapper .status-incomplete-field {
        width: 27% !important;
    }
    .operator-form-wrapper .section-wrapper .phone-verfication-wrapper .phone-container .ant-input {
        padding-left: 4rem;
    }
    form .ant-select, .operator-form-wrapper .ant-input {
        width: 100% !important;
    }
    .phone-verfication-wrapper .sms-message-wrapper {
        flex-direction: column;
    }
    .operator-form-wrapper .section-wrapper .phone-verfication-wrapper .time-container {
        margin: 1rem 0rem 0rem 0rem;
        width: 10rem;
        padding: 0.5rem 0.5rem !important;
    }
    .phone-verfication-wrapper .phone-number-message {
        flex-direction: column;
    }
    .phone-verfication-wrapper .error-msg-container {
        width: 100% !important;
        margin: 1rem 0rem 0rem 0rem !important;
    }
    @media (max-width:280px) {
    .operator-form-wrapper .section-wrapper .ant-form {
        padding: 1rem 0.5rem;
    }
    .operator-form-wrapper .status-incomplete-field {
        width: 30% !important;
    }
}
}
`
export const AgreementWrapper = styled.div` 

.agreement-document-wrapper {
    height: 100Vh;
}
.agreement-document-content {
    width: 80%;
}
.section-wrapper {
    width: 100% !important;
    margin-bottom: 5rem;
    padding: 2rem 2rem 6rem 2rem;
}
.img-wrapper {
    display: flex;
    .business-field {
    margin-left: 5rem;
}
    .incomplete-field {
        color: #FF0000 !important;
        margin-left: 20px;
    }

    .complete-field {
        color: #009B29 !important;
        margin-left: 20px;
    }

    .submit-field {
        color: #FF8800 !important;
        margin-left: 20px;
        width: 5rem;
    }

    .operator-image, .business-image {
        width:50px;
        height: 80px;
    }
    .img-content-wrapper{
        margin: 1rem;
    }
}
.requirement-wrapper {
    margin-left: 9.5rem;
}
.requirement-wrapper-submit {
    margin-left: 10rem;
}
.img-header {
    margin-left: 3rem;
    color: #ffffff;
    /* font-weight: 600; */
}
.View-agreement-btn {
    width: 28%;
    margin-top: 1rem;
}

@media (max-width: 550px) {
    .section-wrapper {
        padding: 2rem 2rem 8rem 2rem;
    }
    .img-wrapper-operator-business {
        display: flex;
        flex-direction: column;
    }
    .img-field-operator-business {
        justify-content: center;
    }
    .img-header-operator-business {
        text-align: center;
    }
    .img-wrapper .business-field {
        margin-left: 0px;
    }
    .View-agreement-btn {
        width: 60%;
    }
    .status-incomplete-field {
        width: 24% !important;
        font-size: 11px;
    }
}

@media (max-width: 280px) {
    .agreement-document-content {
        width: 100%;
    }
}
`
export const BusinessWrapper = styled.div`
h3 {
    margin-top: 1rem !important;
}
.header-content {
    width: 15%;
}
.custom-line {
    width: 1rem;
    height: 1rem;
}
.business-wrapper .ant-input {
    width: 33%;
    border-radius: 0%;
}
.business-wrapper form .ant-select {
    width: 33%;
}
.custom-line {
    width: 4rem;
    height: 0.10rem;
    background-color: #fff;
    margin: 1.25rem 0rem 0.5rem 0rem;
}
.custom-upload-list {
    display:flex;
    margin-bottom:5px;
    width:42%;
    align-items:center;
    padding:1rem;
    border: 1px dashed #707070;

    span {
        width: 10%;
    }

    p {
        color:#ffffff;
    }

    >div {
        width:90%;

        p {
            margin-bottom:0px;
        }

        div {
            display :flex;

            .blue-text {
                text-decoration :underline;
                color:#3A4FFF;
                margin-left:5px;
                opacity:100%;
                cursor :pointer;
            }
        }
    }

}
.custom-upload-field {
    width:42%;
    .ant-upload-list {
        display :none;
    }
}
.upload-field-content {
    display:flex;
    align-items:center;
    padding:1rem;
    border:1px dashed #70707066 ;
    
    div {
        margin-left: 1rem;
        margin-bottom:0px !important;

        p {
          font-size:11px;
        }
    }
}
.business-wrapper .ant-form-item-control {
    line-height: 1rem;
}
.registration-submit-btn {
    width: 25%;
    margin: 2rem 0rem 2rem 0rem;
}
.registration-footer-content {
    width: 40%;
    color: #FF0000;
}
.tick-img {
            width: 15px;
            height: 23px;
        }
.optional-field {
    margin: 8px 0px 0px 10px;
    color: #A8A8B1;
}
.business-wrapper .ant-tooltip-inner {
    color: #212121 !important;
    background-color: #A8A8B1 !important;
}
.exclamation-icon {
    margin: 18px 0px 0px 6px;
}
.custom-input {
    width: 5rem !important;
    height: 20px;
    /* position: absolute; */
}
.custom-name {
    position: relative;
}
.text-wrap {
    overflow: hidden;
    text-overflow: ellipsis;
}
@media (max-width: 1439px) {
    .business-wrapper .ant-input, .business-wrapper form .ant-select {
        width: 50% !important;
    }
}
@media (max-width: 1024px) {
    .business-wrapper .ant-input, .business-wrapper form .ant-select {
        width: 50% !important;
    }
}
@media (max-width: 768px) {
    .section-wrapper {
        margin: 1rem 0rem 1rem 0rem;
        width: 100%;
    }
    .status-incomplete-field {
        width: 16%;
        font-size: 15px;
    }
}
@media (max-width: 550px) {
    .business-wrapper .ant-input, .business-wrapper form .ant-select {
        width: 100% !important;
    }
    .section-wrapper { 
        padding: 1.25rem;
    }
    .status-incomplete-field {
        font-size: 13px;
    }
}
@media (max-width: 320px) {
    .status-incomplete-field {
        font-size: 11px;
        width: 25% !important;
    }
}
@media (max-width: 280px) {
    .display-block {
        display: block !important;
    }
    .status-incomplete-field {
        font-size: 13px;
        width: 85% !important;
        margin-left: 1.25rem;
        .section-wrapper { 
        padding: 0.15rem;
    }
    }
    .section-wrapper { 
        padding: 1.25rem 1.25rem 0rem 1.25rem;
    }
}
`